import styled, { css } from 'styled-components';
import { Text } from 'components/primitives/typography';
import { FlexCenterBoth } from 'components/primitives/flex';

interface Props {
  title: string;
  backAction?: () => void;
}

export default function PageHeader({ title, backAction }: Props) {
  return (
    <Wrapper hasArrow={!backAction}>
      {backAction && (
        <FlexCenterBoth
          height="32px"
          width="32px"
          cursor="pointer"
          onClick={backAction}
          background="#F5F7F9"
          borderRadius="50%"
        >
          <Arrow />
        </FlexCenterBoth>
      )}
      <Text tAlign="center" fWeight={600} fSize="21px">
        {title}
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ hasArrow: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  ${({ hasArrow }) =>
    hasArrow &&
    css`
      grid-template-columns: auto;
    `}
`;

const Arrow = () => (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.999999 5.99999L6.14238 10.8619C6.33706 11.046 6.6593 11.046 6.85399 10.8619C7.04867 10.6779 7.04867 10.3732 6.85399 10.1891L2.42322 5.99999L6.85399 1.81085C7.04867 1.62678 7.04867 1.32211 6.85399 1.13804C6.6593 0.953976 6.33706 0.953976 6.14238 1.13804L0.999999 5.99999Z"
      fill="#5E696A"
    />
    <path
      d="M0.999999 5.99999L0.656491 5.63667C0.556599 5.73112 0.499999 5.86252 0.499999 5.99999C0.499999 6.13746 0.556599 6.26887 0.656491 6.36331L0.999999 5.99999ZM6.14238 10.8619L6.48589 10.4986L6.14238 10.8619ZM6.85399 10.1891L7.19749 9.82582L6.85399 10.1891ZM2.42322 5.99999L2.07971 5.63667L1.69543 5.99999L2.07971 6.36331L2.42322 5.99999ZM6.85399 1.81085L7.19749 2.17417H7.19749L6.85399 1.81085ZM6.14238 1.13804L5.79887 0.774723L6.14238 1.13804ZM0.656491 6.36331L5.79887 11.2253L6.48589 10.4986L1.34351 5.63667L0.656491 6.36331ZM5.79887 11.2253C6.1863 11.5916 6.81006 11.5916 7.19749 11.2253L6.51048 10.4986C6.51215 10.497 6.51272 10.4972 6.51064 10.498C6.50823 10.4989 6.50386 10.5 6.49818 10.5C6.49251 10.5 6.48813 10.4989 6.48572 10.498C6.48365 10.4972 6.48422 10.497 6.48589 10.4986L5.79887 11.2253ZM7.19749 11.2253C7.60084 10.8439 7.60084 10.2072 7.19749 9.82582L6.51048 10.5525C6.50865 10.5507 6.50561 10.547 6.50325 10.5414C6.50105 10.5362 6.5 10.5308 6.5 10.5255C6.5 10.5203 6.50105 10.5148 6.50325 10.5097C6.50561 10.5041 6.50865 10.5004 6.51048 10.4986L7.19749 11.2253ZM7.19749 9.82582L2.76672 5.63667L2.07971 6.36331L6.51048 10.5525L7.19749 9.82582ZM2.76672 6.36331L7.19749 2.17417L6.51048 1.44753L2.07971 5.63667L2.76672 6.36331ZM7.19749 2.17417C7.60084 1.79282 7.60084 1.15607 7.19749 0.774723L6.51048 1.50137C6.50865 1.49963 6.50561 1.49587 6.50325 1.49033C6.50105 1.48514 6.5 1.47972 6.5 1.47445C6.5 1.46918 6.50105 1.46375 6.50325 1.45856C6.50561 1.45302 6.50865 1.44926 6.51048 1.44753L7.19749 2.17417ZM7.19749 0.774723C6.81006 0.408416 6.1863 0.408416 5.79887 0.774723L6.48589 1.50137C6.48422 1.50294 6.48365 1.50276 6.48572 1.50198C6.48813 1.50106 6.49251 1.49999 6.49818 1.49999C6.50386 1.49999 6.50823 1.50106 6.51064 1.50198C6.51272 1.50276 6.51215 1.50294 6.51048 1.50137L7.19749 0.774723ZM5.79887 0.774723L0.656491 5.63667L1.34351 6.36331L6.48589 1.50137L5.79887 0.774723Z"
      fill="#5E696A"
    />
  </svg>
);
